import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id/reports")({
  staticData: {
    title: "common.reports",
  },
});
